export default defineNuxtRouteMiddleware((to, from) => {
  // omit these routes
  const authRoutes = [
    "/signin",
    "/signup",
    "/reset-password",
    "/signup/verify",
    "/auth/callback",
  ];
  const { status } = useAuth();

  // if (status.value === "authenticated") {
  //   return;
  // }

  // localStorage.setItem("compare-program", JSON.stringify([]));
  console.log(to.path);

  if (!authRoutes.includes(to.path) && to.path !== "/ServiceWorker.js") {
    const expirationTime = 60 * 60 * 24; // 1 day
    const lastVisitedPage = useCookie("lastVisitedPage", {
      maxAge: expirationTime,
    });

    lastVisitedPage.value = JSON.stringify({
      path: to.path,
      query: to.query,
    });
  }
});
